const quoteStatuses = {
	QUOTE: "QUOTE",
	BOUND: "BOUND",
	DECLINED: "DECLINED",
	REFERRED: "REFERRED",
	RENEWED: "RENEWED",
	RENEWALSENT: "RENEWALSENT",
	RENEWING: "RENEWING",
	LAPSED: "LAPSED",
	LIVEPAID: "LIVEPAID",
	LIVEUNPAID: "LIVEUNPAID",
	LIVEFINANCE: "LIVEFINANCE",
	NTU: "NTU",
};

export default quoteStatuses;
